// import { Add as AddIcon, ArrowRightAlt as ArrowRightIcon } from '@mui/icons-material';
// import {
//   Alert,
//   Avatar,
//   Box,
//   Button,
//   Card,
//   CardContent,
//   CardMedia,
//   Grid,
//   ListItemIcon,
//   Menu,
//   MenuItem,
//   Skeleton,
//   Snackbar,
//   ThemeProvider,
//   Typography,
//   alpha,
//   createTheme,
//   useMediaQuery,
//   useTheme
// } from '@mui/material';
// import { useAppDispatch, useAppSelector } from 'app/hooks';
// import { motion } from 'framer-motion';
// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { fetchServicesByGroup } from 'slices/NdisSlices/platformAdmin/ManageServicesSlice';
// import { setSelectedService, setSelectedServiceTitle } from 'slices/selectedServiceSlice';

// const customTheme = createTheme({
//   typography: {
//     fontFamily: [
//       'Inter',
//       '-apple-system',
//       'BlinkMacSystemFont',
//       '"Segoe UI"',
//       'Roboto',
//       '"Helvetica Neue"',
//       'Arial',
//       'sans-serif'
//     ].join(','),
//     h4: {
//       fontWeight: 700,
//       fontSize: '1.5rem',
//       lineHeight: 1.25
//     },
//     h5: {
//       fontWeight: 600,
//       fontSize: '1.125rem',
//       lineHeight: 1.3
//     },
//     h6: {
//       fontWeight: 600,
//       fontSize: '1rem',
//       lineHeight: 1.4
//     },
//     subtitle1: {
//       fontWeight: 500,
//       fontSize: '0.875rem',
//       lineHeight: 1.5
//     },
//     body1: {
//       fontSize: '0.8125rem',
//       lineHeight: 1.5
//     },
//     body2: {
//       fontSize: '0.75rem',
//       lineHeight: 1.5
//     },
//     button: {
//       fontWeight: 600,
//       textTransform: 'none',
//       fontSize: '0.75rem'
//     }
//   },
//   components: {
//     MuiCard: {
//       styleOverrides: {
//         root: {
//           borderRadius: '12px',
//           transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
//         }
//       }
//     },
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: '8px',
//           padding: '8px 16px',
//           minWidth: 'auto'
//         }
//       }
//     }
//   }
// });

// interface Service {
//   header: string;
//   service_id: string;
//   icon?: string;
//   PrimaryRender: boolean;
//   route?: string;
//   description?: string;
// }

// interface CustomService extends Service {
//   isCustom?: boolean;
// }

// interface HomeTilesProps {
//   selectedProject: string | null;
//   isAdmin?: boolean ;
// }

// const ProfessionalServiceCard = ({ service }: { service: Service }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isSmallMobile = useMediaQuery('(max-width:400px)');
//   const navigate = useNavigate();
//   const dispatch = useAppDispatch();
//   const selectedProjectHomeTile = useAppSelector(
//     (state) => state.homeTilesServices.selectedProject
//   );

//   return (
//     <Card
//       sx={{
//         height: '100%',
//         minHeight: isSmallMobile ? 320 : 340,
//         display: 'flex',
//         flexDirection: 'column',
//         borderRadius: '12px',
//         border: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
//         boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
//         transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
//         '&:hover': {
//           boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
//           borderColor: alpha(theme.palette.primary.main, 0.4),
//           transform: 'translateY(-4px)'
//         }
//       }}
//     >
//       {service.icon && service.icon.startsWith('data:image') ? (
//         <CardMedia
//           component="img"
//           image={service.icon}
//           alt={service.header}
//           sx={{
//             height: isSmallMobile ? 140 : 160,
//             objectFit: 'contain',
//             padding: '16px',
//             borderTopLeftRadius: '12px',
//             borderTopRightRadius: '12px',
//             backgroundColor: alpha(theme.palette.background.paper, 0.9),
//             borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//             flexShrink: 0
//           }}
//         />
//       ) : (
//         <Box
//           sx={{
//             height: isSmallMobile ? 140 : 160,
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             background: `linear-gradient(135deg, ${alpha(
//               theme.palette.primary.light,
//               0.1
//             )}, ${alpha(theme.palette.secondary.light, 0.05)})`,
//             borderTopLeftRadius: '12px',
//             borderTopRightRadius: '12px',
//             borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//             flexShrink: 0
//           }}
//         >
//           <Typography
//             variant="h4"
//             sx={{
//               color: theme.palette.primary.main,
//               fontWeight: 700,
//               fontSize: '2rem',
//               opacity: 0.8
//             }}
//           >
//             {service.header.substring(0, 2).toUpperCase()}
//           </Typography>
//         </Box>
//       )}

//       <CardContent
//         sx={{
//           p: isSmallMobile ? '16px' : '20px',
//           flexGrow: 1,
//           display: 'flex',
//           flexDirection: 'column'
//         }}
//       >
//         <Typography
//           variant="h6"
//           sx={{
//             mb: '12px',
//             fontWeight: 600,
//             color: theme.palette.text.primary,
//             fontSize: isSmallMobile ? '1rem' : '1.125rem'
//           }}
//         >
//           {service.header}
//         </Typography>

//         {service.description && (
//           <Typography
//             variant="body2"
//             sx={{
//               mb: '16px',
//               color: theme.palette.text.secondary,
//               flexGrow: 1,
//               fontSize: isSmallMobile ? '0.8125rem' : '0.875rem',
//               lineHeight: 1.5,
//               display: '-webkit-box',
//               WebkitLineClamp: 3,
//               WebkitBoxOrient: 'vertical',
//               overflow: 'hidden'
//             }}
//           >
//             {service.description}
//           </Typography>
//         )}

//         <Button
//           fullWidth
//           variant="outlined"
//           endIcon={<ArrowRightIcon />}
//           sx={{
//             mt: 'auto',
//             borderRadius: '8px',
//             py: '10px',
//             fontWeight: 600,
//             fontSize: '0.875rem',
//             borderWidth: '1.5px',
//             '&:hover': {
//               borderWidth: '1.5px',
//               backgroundColor: alpha(theme.palette.primary.main, 0.08)
//             }
//           }}
//           onClick={() => {
//             console.log('service', service);
//             if (selectedProjectHomeTile) {
//               dispatch(setSelectedServiceTitle(service.header));
//               dispatch(setSelectedService({ title: service.header, id: service.service_id }));
//               service.route
//                 ? navigate(service.route)
//                 : navigate(`/details/${service.header.replace(/\s+/g, '-')}`);
//             }
//           }}
//         >
//           Explore Service
//         </Button>
//       </CardContent>
//     </Card>
//   );
// };

// const HomeTiles: React.FC<HomeTilesProps> = ({ selectedProject }) => {
//   const defaultTheme = useTheme();
//   const isMobile = useMediaQuery(defaultTheme.breakpoints.down('sm'));
//   const isSmallMobile = useMediaQuery('(max-width:400px)');
//   const navigate = useNavigate();
//   const dispatch = useAppDispatch();

//   const { services, loading, error } = useAppSelector((state) => state.manageServices);
//   const selectedProjectHomeTile = useAppSelector(
//     (state) => state.homeTilesServices.selectedProject
//   );

//   const [serviceList, setServiceList] = useState<string[]>([]);
//   const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
//   const [openSnackbar, setOpenSnackbar] = useState(false);

//   const userDetails = localStorage.getItem('user-details');
//   const parsedUserDetails = userDetails ? JSON.parse(userDetails) : null;
//   const email = parsedUserDetails?.email || '';

//   useEffect(() => {
//     if (selectedProject && email) {
//       dispatch(fetchServicesByGroup({ email, group_id: selectedProject }));
//     }
//   }, [dispatch, selectedProject, email]);

//   const primaryServices = services.filter((service) => service.PrimaryRender);
//   const nonPrimaryServices = services.filter((service) => !service.PrimaryRender);

//   const allServices: CustomService[] = [
//     ...primaryServices,
//     ...(serviceList
//       .map((name) => {
//         const service = nonPrimaryServices.find((s) => s.header === name);
//         return service ? { ...service, isCustom: true } : null;
//       })
//       .filter(Boolean) as CustomService[])
//   ];

//   const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
//     if (selectedProjectHomeTile) {
//       setAnchorEl(event.currentTarget);
//     } else {
//       setOpenSnackbar(true);
//     }
//   };

//   const handleMenuItemClick = (serviceHeader: string) => {
//     if (!serviceList.includes(serviceHeader)) {
//       setServiceList((prev) => [...prev, serviceHeader]);
//     }
//     handleClose();
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   const handleSnackbarClose = () => {
//     setOpenSnackbar(false);
//   };

//   const containerVariants = {
//     hidden: { opacity: 0 },
//     show: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.1,
//         delayChildren: 0.2
//       }
//     }
//   };

//   const itemVariants = {
//     hidden: { opacity: 0, y: 20, scale: 0.95 },
//     show: {
//       opacity: 1,
//       y: 0,
//       scale: 1,
//       transition: {
//         type: 'spring',
//         stiffness: 300,
//         damping: 20
//       }
//     },
//     hover: {
//       y: -6,
//       transition: {
//         type: 'spring',
//         stiffness: 400
//       }
//     }
//   };

//   return (
//     <ThemeProvider theme={customTheme}>
//       <Box
//         sx={{
//           width: '100%',
//           maxWidth: 1400,
//           mx: 'auto',
//           px: isSmallMobile ? '16px' : isMobile ? '20px' : '24px',
//           py: isSmallMobile ? '20px' : '24px'
//         }}
//       >
//         {loading && (
//           <Grid container spacing={isSmallMobile ? 2 : 3}>
//             {[...Array(6)].map((_, i) => (
//               <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={i}>
//                 <Skeleton
//                   variant="rounded"
//                   width="100%"
//                   height={isSmallMobile ? 320 : 340}
//                   sx={{
//                     borderRadius: '12px'
//                   }}
//                 />
//               </Grid>
//             ))}
//           </Grid>
//         )}

//         {!loading && !error && allServices.length > 0 && (
//           <motion.div variants={containerVariants} initial="hidden" animate="show">
//             <Grid container spacing={isSmallMobile ? 2 : 3}>
//               {allServices.map((service, index) => (
//                 <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={`${service.header}-${index}`}>
//                   <motion.div
//                     variants={itemVariants}
//                     whileHover="hover"
//                     transition={{ type: 'spring', stiffness: 400 }}
//                     // style={{ height: '100%' }}
//                   >
//                     <ProfessionalServiceCard service={service} />
//                   </motion.div>
//                 </Grid>
//               ))}
//             </Grid>
//           </motion.div>
//         )}

//         {!loading && !error && allServices.length === 0 && (
//           <Box
//             sx={{
//               display: 'flex',
//               flexDirection: 'column',
//               alignItems: 'center',
//               justifyContent: 'center',
//               minHeight: '300px',
//               textAlign: 'center',
//               p: '24px'
//             }}
//           >
//             <Typography
//               variant="h5"
//               sx={{
//                 mb: '12px',
//                 color: defaultTheme.palette.text.secondary,
//                 fontWeight: 500
//               }}
//             >
//               No services available
//             </Typography>
//             <Typography
//               variant="body1"
//               sx={{
//                 color: defaultTheme.palette.text.secondary,
//                 maxWidth: '500px',
//                 mb: '16px'
//               }}
//             >
//               There are currently no services configured for this team. Please contact your
//               administrator to add services.
//             </Typography>
//           </Box>
//         )}

//         {error && (
//           <Box
//             sx={{
//               display: 'flex',
//               flexDirection: 'column',
//               alignItems: 'center',
//               justifyContent: 'center',
//               minHeight: '300px',
//               textAlign: 'center',
//               p: '24px'
//             }}
//           >
//             <Typography
//               variant="h5"
//               sx={{
//                 mb: '12px',
//                 color: defaultTheme.palette.error.main,
//                 fontWeight: 500
//               }}
//             >
//               Error loading services
//             </Typography>
//             <Typography
//               variant="body1"
//               sx={{
//                 color: defaultTheme.palette.text.secondary,
//                 maxWidth: '500px',
//                 mb: '16px'
//               }}
//             >
//               We encountered an issue loading services. Please try again later.
//             </Typography>
//             <Button
//               variant="contained"
//               onClick={() =>
//                 dispatch(fetchServicesByGroup({ email, group_id: selectedProject || '' }))
//               }
//               sx={{
//                 borderRadius: '8px',
//                 px: '24px',
//                 py: '10px',
//                 fontSize: '0.875rem'
//               }}
//             >
//               Retry
//             </Button>
//           </Box>
//         )}

//         <Box sx={{ display: 'flex', justifyContent: 'center', mt: '24px' }}>
//           <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
//             <Button
//               variant="outlined"
//               startIcon={<AddIcon />}
//               onClick={handleClick}
//               sx={{
//                 px: '24px',
//                 py: '10px',
//                 borderRadius: '8px',
//                 fontWeight: 600,
//                 borderWidth: '1.5px',
//                 fontSize: '0.875rem',
//                 '&:hover': {
//                   borderWidth: '1.5px'
//                 }
//               }}
//             >
//               Link another service
//             </Button>
//           </motion.div>
//         </Box>

//         <Menu
//           anchorEl={anchorEl}
//           open={Boolean(anchorEl)}
//           onClose={handleClose}
//           PaperProps={{
//             sx: {
//               mt: '8px',
//               borderRadius: '12px',
//               minWidth: '240px',
//               py: 0,
//               boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
//               border: `1px solid ${alpha(defaultTheme.palette.divider, 0.2)}`
//             }
//           }}
//           MenuListProps={{
//             sx: {
//               py: 0
//             }
//           }}
//         >
//           <Typography
//             variant="subtitle1"
//             sx={{
//               px: '16px',
//               py: '12px',
//               fontWeight: 600,
//               fontSize: '0.875rem',
//               borderBottom: `1px solid ${alpha(defaultTheme.palette.divider, 0.1)}`,
//               color: defaultTheme.palette.text.primary
//             }}
//           >
//             Available Services
//           </Typography>
//           {nonPrimaryServices.map((service) => (
//             <motion.div
//               key={service.header}
//               whileHover={{ x: 4 }}
//               transition={{ type: 'spring', stiffness: 300 }}
//             >
//               <MenuItem
//                 onClick={() => handleMenuItemClick(service.header)}
//                 sx={{
//                   py: '10px',
//                   borderBottom: `1px solid ${alpha(defaultTheme.palette.divider, 0.05)}`,
//                   '&:last-child': {
//                     borderBottom: 'none'
//                   }
//                 }}
//               >
//                 <ListItemIcon sx={{ minWidth: '36px' }}>
//                   {service.icon && service.icon.startsWith('data:image') ? (
//                     <Avatar
//                       src={service.icon}
//                       sx={{
//                         width: '28px',
//                         height: '28px',
//                         bgcolor: alpha(defaultTheme.palette.primary.main, 0.1)
//                       }}
//                     />
//                   ) : (
//                     <Avatar
//                       sx={{
//                         width: '28px',
//                         height: '28px',
//                         bgcolor: alpha(defaultTheme.palette.primary.main, 0.1),
//                         color: defaultTheme.palette.primary.main,
//                         fontSize: '0.875rem'
//                       }}
//                     >
//                       {service.header.charAt(0).toUpperCase()}
//                     </Avatar>
//                   )}
//                 </ListItemIcon>
//                 <Typography
//                   variant="body1"
//                   sx={{
//                     fontWeight: 500,
//                     ml: '8px',
//                     fontSize: '0.8125rem',
//                     color: defaultTheme.palette.text.primary
//                   }}
//                 >
//                   {service.header}
//                 </Typography>
//               </MenuItem>
//             </motion.div>
//           ))}
//         </Menu>

//         <Snackbar
//           open={openSnackbar}
//           autoHideDuration={6000}
//           onClose={handleSnackbarClose}
//           anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//         >
//           <motion.div
//             initial={{ scale: 0.9, opacity: 0 }}
//             animate={{ scale: 1, opacity: 1 }}
//             exit={{ scale: 0.9, opacity: 0 }}
//           >
//             <Alert
//               severity="warning"
//               onClose={handleSnackbarClose}
//               sx={{
//                 width: '100%',
//                 borderRadius: '8px',
//                 boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//                 fontSize: '0.8125rem',
//                 alignItems: 'center'
//               }}
//             >
//               Please select a team first to add services
//             </Alert>
//           </motion.div>
//         </Snackbar>
//       </Box>
//     </ThemeProvider>
//   );
// };

// export default HomeTiles;




import { Add as AddIcon, ArrowRightAlt as ArrowRightIcon } from '@mui/icons-material';
import {
  Alert,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  ListItemIcon,
  Menu,
  MenuItem,
  Skeleton,
  Snackbar,
  ThemeProvider,
  Typography,
  alpha,
  createTheme,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { generateDynamicServiceMenus } from 'components/app/MenuItems';
import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchServicesByGroup } from 'slices/NdisSlices/platformAdmin/ManageServicesSlice';
import { setSelectedService, setSelectedServiceTitle } from 'slices/selectedServiceSlice';

const customTheme = createTheme({
  typography: {
    fontFamily: [
      'Inter',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif'
    ].join(','),
    h4: {
      fontWeight: 700,
      fontSize: '1.5rem',
      lineHeight: 1.25
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.125rem',
      lineHeight: 1.3
    },
    h6: {
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: 1.4
    },
    subtitle1: {
      fontWeight: 500,
      fontSize: '0.875rem',
      lineHeight: 1.5
    },
    body1: {
      fontSize: '0.8125rem',
      lineHeight: 1.5
    },
    body2: {
      fontSize: '0.75rem',
      lineHeight: 1.5
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
      fontSize: '0.75rem'
    }
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          padding: '8px 16px',
          minWidth: 'auto'
        }
      }
    }
  }
});

interface Service {
  header: string;
  service_id: string;
  icon?: string;
  PrimaryRender: boolean;
  route?: string;
  description?: string;
}

interface CustomService extends Service {
  isCustom?: boolean;
}

interface HomeTilesProps {
  selectedProject: string | null;
  isAdmin?: boolean;
}

const ProfessionalServiceCard = ({ service }: { service: Service }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isSmallMobile = useMediaQuery('(max-width:400px)');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const selectedProjectHomeTile = useAppSelector(
    (state) => state.homeTilesServices.selectedProject
  );

  return (
    <Card
      sx={{
        height: '100%',
        minHeight: isSmallMobile ? 320 : 340,
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '12px',
        border: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
          borderColor: alpha(theme.palette.primary.main, 0.4),
          transform: 'translateY(-4px)'
        }
      }}
    >
      {service.icon && service.icon.startsWith('data:image') ? (
        <CardMedia
          component="img"
          image={service.icon}
          alt={service.header}
          sx={{
            height: isSmallMobile ? 140 : 160,
            objectFit: 'contain',
            padding: '16px',
            borderTopLeftRadius: '12px',
            borderTopRightRadius: '12px',
            backgroundColor: alpha(theme.palette.background.paper, 0.9),
            borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            flexShrink: 0
          }}
        />
      ) : (
        <Box
          sx={{
            height: isSmallMobile ? 140 : 160,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: `linear-gradient(135deg, ${alpha(
              theme.palette.primary.light,
              0.1
            )}, ${alpha(theme.palette.secondary.light, 0.05)})`,
            borderTopLeftRadius: '12px',
            borderTopRightRadius: '12px',
            borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            flexShrink: 0
          }}
        >
          <Typography
            variant="h4"
            sx={{
              color: theme.palette.primary.main,
              fontWeight: 700,
              fontSize: '2rem',
              opacity: 0.8
            }}
          >
            {service.header.substring(0, 2).toUpperCase()}
          </Typography>
        </Box>
      )}

      <CardContent
        sx={{
          p: isSmallMobile ? '16px' : '20px',
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Typography
          variant="h6"
          sx={{
            mb: '12px',
            fontWeight: 600,
            color: theme.palette.text.primary,
            fontSize: isSmallMobile ? '1rem' : '1.125rem'
          }}
        >
          {service.header}
        </Typography>

        {service.description && (
          <Typography
            variant="body2"
            sx={{
              mb: '16px',
              color: theme.palette.text.secondary,
              flexGrow: 1,
              fontSize: isSmallMobile ? '0.8125rem' : '0.875rem',
              lineHeight: 1.5,
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden'
            }}
          >
            {service.description}
          </Typography>
        )}

        <Button
          fullWidth
          variant="outlined"
          endIcon={<ArrowRightIcon />}
          sx={{
            mt: 'auto',
            borderRadius: '8px',
            py: '10px',
            fontWeight: 600,
            fontSize: '0.875rem',
            borderWidth: '1.5px',
            '&:hover': {
              borderWidth: '1.5px',
              backgroundColor: alpha(theme.palette.primary.main, 0.08)
            }
          }}
          onClick={() => {
            console.log('service clicked:', service);
            if (selectedProjectHomeTile) {
              dispatch(setSelectedServiceTitle(service.header));
              dispatch(setSelectedService({ title: service.header, id: service.service_id }));
              service.route
                ? navigate(service.route)
                : navigate(`/details/${service.header.replace(/\s+/g, '-')}`);
            }
          }}
        >
          Explore Service
        </Button>
      </CardContent>
    </Card>
  );
};

const HomeTiles: React.FC<HomeTilesProps> = ({ selectedProject }) => {
  const defaultTheme = useTheme();
  const isMobile = useMediaQuery(defaultTheme.breakpoints.down('sm'));
  const isSmallMobile = useMediaQuery('(max-width:400px)');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { services, loading, error } = useAppSelector((state) => state.manageServices);
  const selectedProjectHomeTile = useAppSelector(
    (state) => state.homeTilesServices.selectedProject
  );

  const [serviceList, setServiceList] = useState<string[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [dynamicMenuItems, setDynamicMenuItems] = useState<any[]>([]);

  const userDetails = localStorage.getItem('user-details');
  const parsedUserDetails = userDetails ? JSON.parse(userDetails) : null;
  const email = parsedUserDetails?.email || '';

  useEffect(() => {
    if (selectedProject && email) {
      dispatch(fetchServicesByGroup({ email, group_id: selectedProject }));
    }
  }, [dispatch, selectedProject, email]);

  // Generate dynamic menu items when services are loaded
  useEffect(() => {
    if (services && services.length > 0) {
      const dynamicMenus = generateDynamicServiceMenus(services);
      setDynamicMenuItems(dynamicMenus);
      console.log('Dynamic menu items generated:', dynamicMenus);

      // You can also dispatch an action to update navigation services globally
      // dispatch(updateNavigationServices(services));
    }
  }, [services]);

  const primaryServices = services.filter((service) => service.PrimaryRender);
  const nonPrimaryServices = services.filter((service) => !service.PrimaryRender);

  const allServices: CustomService[] = [
    ...primaryServices,
    ...(serviceList
      .map((name) => {
        const service = nonPrimaryServices.find((s) => s.header === name);
        return service ? { ...service, isCustom: true } : null;
      })
      .filter(Boolean) as CustomService[])
  ];

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (selectedProjectHomeTile) {
      setAnchorEl(event.currentTarget);
    } else {
      setOpenSnackbar(true);
    }
  };

  const handleMenuItemClick = (serviceHeader: string) => {
    if (!serviceList.includes(serviceHeader)) {
      setServiceList((prev) => [...prev, serviceHeader]);
    }
    handleClose();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20, scale: 0.95 },
    show: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 20
      }
    },
    hover: {
      y: -6,
      transition: {
        type: 'spring',
        stiffness: 400
      }
    }
  };

  return (
    <ThemeProvider theme={customTheme}>
      <Box
        sx={{
          width: '100%',
          maxWidth: 1400,
          mx: 'auto',
          px: isSmallMobile ? '16px' : isMobile ? '20px' : '24px',
          py: isSmallMobile ? '20px' : '24px'
        }}
      >
        {loading && (
          <Grid container spacing={isSmallMobile ? 2 : 3}>
            {[...Array(6)].map((_, i) => (
              <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={i}>
                <Skeleton
                  variant="rounded"
                  width="100%"
                  height={isSmallMobile ? 320 : 340}
                  sx={{
                    borderRadius: '12px'
                  }}
                />
              </Grid>
            ))}
          </Grid>
        )}

        {!loading && !error && allServices.length > 0 && (
          <motion.div variants={containerVariants} initial="hidden" animate="show">
            <Grid container spacing={isSmallMobile ? 2 : 3}>
              {allServices.map((service, index) => (
                <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={`${service.header}-${index}`}>
                  <motion.div
                    variants={itemVariants}
                    whileHover="hover"
                    transition={{ type: 'spring', stiffness: 400 }}
                  >
                    <ProfessionalServiceCard service={service} />
                  </motion.div>
                </Grid>
              ))}
            </Grid>
          </motion.div>
        )}

        {!loading && !error && allServices.length === 0 && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '300px',
              textAlign: 'center',
              p: '24px'
            }}
          >
            <Typography
              variant="h5"
              sx={{
                mb: '12px',
                color: defaultTheme.palette.text.secondary,
                fontWeight: 500
              }}
            >
              No services available
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: defaultTheme.palette.text.secondary,
                maxWidth: '500px',
                mb: '16px'
              }}
            >
              There are currently no services configured for this team. Please contact your
              administrator to add services.
            </Typography>
          </Box>
        )}

        {error && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '300px',
              textAlign: 'center',
              p: '24px'
            }}
          >
            <Typography
              variant="h5"
              sx={{
                mb: '12px',
                color: defaultTheme.palette.error.main,
                fontWeight: 500
              }}
            >
              Error loading services
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: defaultTheme.palette.text.secondary,
                maxWidth: '500px',
                mb: '16px'
              }}
            >
              We encountered an issue loading services. Please try again later.
            </Typography>
            <Button
              variant="contained"
              onClick={() =>
                dispatch(fetchServicesByGroup({ email, group_id: selectedProject || '' }))
              }
              sx={{
                borderRadius: '8px',
                px: '24px',
                py: '10px',
                fontSize: '0.875rem'
              }}
            >
              Retry
            </Button>
          </Box>
        )}

        <Box sx={{ display: 'flex', justifyContent: 'center', mt: '24px' }}>
          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={handleClick}
              sx={{
                px: '24px',
                py: '10px',
                borderRadius: '8px',
                fontWeight: 600,
                borderWidth: '1.5px',
                fontSize: '0.875rem',
                '&:hover': {
                  borderWidth: '1.5px'
                }
              }}
            >
              Link another service
            </Button>
          </motion.div>
        </Box>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          PaperProps={{
            sx: {
              mt: '8px',
              borderRadius: '12px',
              minWidth: '240px',
              py: 0,
              boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
              border: `1px solid ${alpha(defaultTheme.palette.divider, 0.2)}`
            }
          }}
          MenuListProps={{
            sx: {
              py: 0
            }
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{
              px: '16px',
              py: '12px',
              fontWeight: 600,
              fontSize: '0.875rem',
              borderBottom: `1px solid ${alpha(defaultTheme.palette.divider, 0.1)}`,
              color: defaultTheme.palette.text.primary
            }}
          >
            Available Services
          </Typography>
          {nonPrimaryServices.map((service) => (
            <motion.div
              key={service.header}
              whileHover={{ x: 4 }}
              transition={{ type: 'spring', stiffness: 300 }}
            >
              <MenuItem
                onClick={() => handleMenuItemClick(service.header)}
                sx={{
                  py: '10px',
                  borderBottom: `1px solid ${alpha(defaultTheme.palette.divider, 0.05)}`,
                  '&:last-child': {
                    borderBottom: 'none'
                  }
                }}
              >
                <ListItemIcon sx={{ minWidth: '36px' }}>
                  {service.icon && service.icon.startsWith('data:image') ? (
                    <Avatar
                      src={service.icon}
                      sx={{
                        width: '28px',
                        height: '28px',
                        bgcolor: alpha(defaultTheme.palette.primary.main, 0.1)
                      }}
                    />
                  ) : (
                    <Avatar
                      sx={{
                        width: '28px',
                        height: '28px',
                        bgcolor: alpha(defaultTheme.palette.primary.main, 0.1),
                        color: defaultTheme.palette.primary.main,
                        fontSize: '0.875rem'
                      }}
                    >
                      {service.header.charAt(0).toUpperCase()}
                    </Avatar>
                  )}
                </ListItemIcon>
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 500,
                    ml: '8px',
                    fontSize: '0.8125rem',
                    color: defaultTheme.palette.text.primary
                  }}
                >
                  {service.header}
                </Typography>
              </MenuItem>
            </motion.div>
          ))}
        </Menu>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
          >
            <Alert
              severity="warning"
              onClose={handleSnackbarClose}
              sx={{
                width: '100%',
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                fontSize: '0.8125rem',
                alignItems: 'center'
              }}
            >
              Please select a team first to add services
            </Alert>
          </motion.div>
        </Snackbar>
      </Box>
    </ThemeProvider>
  );
};

export default HomeTiles;
